import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

@Injectable({ providedIn: 'root' })
export class YeehroCalendlyInviteTrackerService {
  private API_URL = '/api/yeehro-calendly-invite-trackers/';
  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(
    private httpClient: HttpClient
  ) {}


  getAll(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.API_URL);
  }


  getById(id: string): Observable<any> {
    return this.httpClient.get<any>(this.API_URL + id);
  }


  // Public (unauthenticated) lookup used by the public booking route to resolve
  // an invite link back to its event + prefill snapshot.
  getByToken(token: string): Observable<any> {
    return this.httpClient.get<any>(this.API_URL + 'by-token/' + token);
  }


  // Public (unauthenticated) — flips a tracker to status='booked' after the
  // invitee completes a booking. Server validates token + event match.
  //
  // winningEventId (optional): open + direct flows resolve/clone the event
  // at commit time, so their trackers start with a null event. Passing the
  // winning event id here lets the server stamp it before the match check.
  markBookedByToken(token: string, bookingId: string, winningEventId?: string | null): Observable<any> {
    const payload: any = { token: token, bookingId: bookingId };
    if (winningEventId) payload.winningEventId = winningEventId;
    return this.httpClient.post<any>(this.API_URL + 'public/mark-booked', JSON.stringify(payload), this.headerOptions);
  }


  create(tracker: any): Observable<any> {
    return this.httpClient.post<any>(this.API_URL, JSON.stringify(tracker), this.headerOptions);
  }


  update(tracker: any): Observable<any> {
    return this.httpClient.put<any>(this.API_URL + tracker._id, JSON.stringify(tracker), this.headerOptions);
  }


  updatePassedFields(id: string, fields: any): Observable<any> {
    return this.httpClient.patch<any>(this.API_URL + id + '/update-passed-fields', JSON.stringify({ fields }), this.headerOptions);
  }


  delete(id: string): Observable<any> {
    return this.httpClient.delete<any>(this.API_URL + id);
  }


  search(searchTerms: any): Observable<any[]> {
    return this.httpClient.post<any[]>(this.API_URL + 'search', JSON.stringify(searchTerms), this.headerOptions);
  }


  getCustomDatasource(searchParams: any, sortField = 'createdAt', sortDirection = 'desc', pageNumber: number = 0, pageSize: number = 25): Observable<any> {
    searchParams.sortField = sortField;
    searchParams.sortOrder = sortDirection;
    searchParams.pageNumber = pageNumber;
    searchParams.pageSize = pageSize;
    return this.httpClient.post<any>(this.API_URL + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
  }


  // Combined send endpoint — backend creates tracker + message + activity + dispatches
  // the email in one call. See the /send route wired up earlier.
  sendInvite(payload: any): Observable<any> {
    return this.httpClient.post<any>(this.API_URL + 'send', JSON.stringify(payload), this.headerOptions);
  }
}